<template>
  <div class="burger mq">
    <a class="burger mq-btn-link" href='https://moonshot.ch/'>Go to website</a>
    <!-- <button class="burger bg-sound-mute mq-mute-btn" @click="muteBgSound">Mute Audio</button>   -->
    <button id="btnMute" class="burger bg-sound-mute mq-mute-btn mq-mute-img" @click="muteBgSound">
      </button>  

  </div>

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppBurger',
  computed: {
  //  ...mapState(['menuOpen']),
  },
  methods:{
    muteBgSound(){
      let bgAudio = document.getElementById("bgsound");
      // Muzzamil for mute btn
      let btnMute = document.getElementById("btnMute");
      if(bgAudio.muted===true)
      {
        bgAudio.muted=false;
        btnMute.setAttribute("class","burger bg-sound-mute mq-mute-btn mq-mute-img");
      }
      else{
         bgAudio.muted=true;
        //  muzzamil for mute btn
         btnMute.setAttribute("class","burger bg-sound-mute mq-mute-btn mq-mute-x");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.bg-sound-mute{
     margin-top: 225px; 
     z-index: -1!important;
}
.burger {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 16px;

  @include mq(ipadL) {
    top: 50px;
    right: 50px;
  }

  pointer-events: all;
  cursor: pointer;
  transition: transform 0.4s $outQuint;

  .burger__line {
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    margin-bottom: 5px;

    background-color: $color-white;
    transition: all 0.4s $outQuint;
    opacity: 0.75;

    &--close {
      position: absolute;
      top: 50%;
      left: 0;
      margin: 0;

      transform: translateY(-50%);
      opacity: 0;
    }

    &--top {
      top: 2px;
      transform-origin: 0 50%;
      transition: all 0.2s $outQuint;
    }

    &--center {
      top: 50%;
      transform: translateY(-50%);
    }

    &--bottom {
      top: 13px;
      transform-origin: 100% 50%;
      transition: all 0.2s $outQuint;
    }
  }

  @include mq($and: $is-not-touch-device) {
    &:not(.burger--close):hover {
      .burger__line {
        opacity: 1;

        &--top {
          top: 0;
        }

        &--bottom {
          top: 15px;
        }
      }
    }
  }

  &.burger--close {
    .burger__line {
      &--top,
      &--bottom {
        transform: scaleX(0);
        transition: all 0.4s $outQuint;
      }

      &--center {
        transition: all 0.4s $outQuint 0.2s;
        transform: translateY(-50%) rotate(45deg);
      }

      &--close {
        transition: all 0.4s $outQuint 0.2s;
        transform: translateY(-50%) rotate(-45deg);
        opacity: 0.75;
      }
    }
  }

  @include mq($and: $is-not-touch-device) {
    &.burger--close:hover {
      transform: scale(1.2);

      .burger__line {
        opacity: 1;

        &--top,
        &--bottom {
          transform: scaleX(0);
        }

        &--close {
          opacity: 1;
        }
      }
    }
  }
}
</style>
